import { SxProps, Theme, Typography, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

export interface NavBarBadgeProps extends PropsWithChildren {
  label: string;
  ariaLabel?: string;
  sxProps?: SxProps;
}

export const NavBarBadge = ({
  label,
  ariaLabel,
  sxProps,
}: NavBarBadgeProps) => {
  const theme = useTheme<Theme>();

  return (
    <Typography
      aria-label={ariaLabel}
      component='p'
      sx={{
        borderRadius: theme.spacing(0.5),
        fontSize: '0.75rem',
        lineHeight: 1.67,
        p: theme.spacing(0.25, 0.5),
        ...sxProps,
      }}
    >
      {label}
    </Typography>
  );
};
